module.exports = __webpack_public_path__ + "img/Galactapedia_Vanduul.76f5c9d7.png";